export let STREAM_SOCKET_MESSAGES;
(function (STREAM_SOCKET_MESSAGES) {
  STREAM_SOCKET_MESSAGES["UPDATE"] = "live-stream-notification";
})(STREAM_SOCKET_MESSAGES || (STREAM_SOCKET_MESSAGES = {}));
//# sourceMappingURL=stream-socket-messages.js.map